module.exports = __webpack_public_path__ + "img/pocket.662f3935.svg";